import { map } from 'lodash/fp';

import canChooseIncomeType from '../can-choose-income-type';
import constants from '../../ahm-constants';

type IncomeTypeOption = {
  text: string;
  value: string;
  disabled?: boolean;
};

const disableSingleIncomeTypeOption = (option: IncomeTypeOption): IncomeTypeOption =>
  option.value === constants.INCOME_TYPE.SINGLE ? { ...option, disabled: true } : option;

const getIncomeTypeOptions = (scale: string = constants.SCALE.SINGLE): Array<IncomeTypeOption> =>
  canChooseIncomeType(scale)
    ? constants.INCOME_TYPE_OPTIONS
    : map(disableSingleIncomeTypeOption, constants.INCOME_TYPE_OPTIONS);

export default getIncomeTypeOptions;
